import instance from '../scorpiusInstance';
import {
  UPDATE_APP_ROLE_START,
  UPDATE_APP_ROLE_SUCCESS,
  UPDATE_APP_ROLE_ERROR,
} from '../types';

export const updateAppRoleStart = (orgId, appName) => ({
  type: UPDATE_APP_ROLE_START,
  orgId,
  appName,
});

export const updateAppRoleSuccess = (orgId, appName, role) => ({
  type: UPDATE_APP_ROLE_SUCCESS,
  orgId,
  appName,
  role,
});

export const updateAppRoleError = (orgId, appName, error) => ({
  type: UPDATE_APP_ROLE_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Updates a role belonging to an organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} role
 * @param {String} role.id - Required
 * @param {String} role.name - Required
 * @param {Array<string>} role.permissions - Required
 */
export const updateAppRole = (orgId, appName, role) => async dispatch => {
  dispatch(updateAppRoleStart(orgId, appName));
  try {
    const patchRole = {
      name: role.name,
      permissions: role.permissions,
    };
    const response = await instance.patch(
      `/organizations/${orgId}/${appName}/roles/${role.id}`,
      patchRole,
      { headers: { retry: true } },
    );

    // NOTE Since the patched response doesn't include the original role fields,
    // merge the patched values into the original role (which includes the id).
    const merged = {
      ...role,
      ...response.data,
    };

    return dispatch(updateAppRoleSuccess(orgId, appName, merged));
  } catch (error) {
    throw dispatch(updateAppRoleError(orgId, appName, error));
  }
};

export default updateAppRole;
